import React from "react";
import SalaryForm from "./containers/SalaryForm";
import Results from "./containers/Results";
import NewResults from "./containers/NewResults";
import Banner from "./containers/Banner";
import {
  setResultsData
} from "helpers";
// import { SnackbarProvider, enqueueSnackbar } from 'notistack';

import { salaryRanges, columnHeaders } from "data/data";

import "./App.css";

class App extends React.Component {
  constructor() {
    super();

    this.displayResults = this.displayResults.bind(this);
    this.displayForm = this.displayForm.bind(this);
    this.updateResultsData = this.updateResultsData.bind(this);
    this.updateFiltersArray = this.updateFiltersArray.bind(this);
    this.updateBarChartData = this.updateBarChartData.bind(this);
    this.updatedIsAuthenticated = this.updatedIsAuthenticated.bind(this);
    this.updateForm = this.updateForm.bind(this);
    this.resetForm = this.resetForm.bind(this);

    this.state = {
      isResultsDisplayed: false,
      filtersArray: ["country"],
      resultsData: {},
      formData: [],
      isAuthenticated: false
    };
  }

  componentDidMount(){
    if(window.isAuthenticated){
      this.setState({
        isAuthenticated: window.isAuthenticated,
      });
    }
  }

  displayResults() {
    this.setState({
      isResultsDisplayed: true,
    });
  }

  updatedIsAuthenticated(){
    this.setState({
      isAuthenticated: true,
    });
  }

  displayForm() {
    this.setState({
      isResultsDisplayed: false,
    });
  }

  updateFiltersArray(newArray) {
    this.setState({
      filtersArray: newArray,
    });
  }

  updateResultsData(
    chartData,
    labels,
    userResponseIndex,
    formData,
    filteredResponses,
    typeOfResult
  ) {
    this.setState({
      resultsData: {
        chartData: chartData,
        labels: labels,
        userResponseIndex: userResponseIndex,
        formData: formData,
        filteredResponses: filteredResponses,
        typeOfResult: typeOfResult
      }
    });
    // this.setState(
    //   {
    //     formData: newFormdata,
    //   },
    //   () => {
    //     setResultsData({
    //       props: this.props,
    //       filtersArray: this.state.filtersArray,
    //       formData: this.state.formData,
    //     });
    //   }
    // );
  }

  updateForm() {
    
  }

  // updateFormData = (newFormData) => {
  //   this.setState({ formData: newFormData });
  // };

  // updateChartData = (newChartData) => {
  //   this.setState((prevState) => ({
  //     resultsData: {
  //       ...prevState.resultsData,
  //       chartData: newChartData,
  //     },
  //   }));
  // };

  // updateLabels = (newLabels) => {
  //   this.setState((prevState) => ({
  //     resultsData: {
  //       ...prevState.resultsData,
  //       labels: newLabels,
  //     },
  //   }));
  // };

  // updateUserResponseIndex = (newIndex) => {
  //   this.setState((prevState) => ({
  //     resultsData: {
  //       ...prevState.resultsData,
  //       userResponseIndex: newIndex,
  //     },
  //   }));
  // };

  resetForm(){
    this.setState({
      isResultsDisplayed: false,
    });

    this.setState({
      filtersArray: ["country"],
    });
  }

  updateBarChartData = ({ chartData, labels, userResponseIndex }) => {
    this.setState({
      resultsData: {
        ...this.state.resultsData,
        chartData,
        labels,
        userResponseIndex,
      },
    });
  };

  render() {
    const { isResultsDisplayed, filtersArray, resultsData, isAuthenticated } = this.state;

    return (
      <div id="App" className={"App " + (isResultsDisplayed ? "flex" : "")} >
        <SalaryForm
          columnHeaders={columnHeaders}
          salaryRanges={salaryRanges}
          displayResults={this.displayResults}
          updateResultsData={this.updateResultsData}
          filtersArray={filtersArray}
          updateForm={this.updateForm}
          isResultsDisplayed={isResultsDisplayed}
          isAuthenticated={isAuthenticated}
          updatedIsAuthenticated={this.updatedIsAuthenticated}
          resultsData={resultsData}
          updateFiltersArray={this.updateFiltersArray}
          resetForm={this.resetForm}
        />
        {isResultsDisplayed ? (
          <NewResults
            resultsData={resultsData}
            isAuthenticated={isAuthenticated}
            filtersArray={filtersArray}
            isResultsDisplayed={isResultsDisplayed}
          />
        ) : (
          ""
        )}
        {/* {isResultsDisplayed ? (
          <Results
            displayForm={this.displayForm}
            resultsData={resultsData}
            updateFiltersArray={this.updateFiltersArray}
            updateResultsData={this.updateResultsData}
            updateForm={this.updateForm}
          />
        ) : (
          ""
        )} */}
      </div>
    );
  }
}

export default App;
